import { gql } from '@apollo/client'

export const RESIGNED_EMPLOYEES_OF_COMPANY_COUNTRY = gql`
  query ResignedEmployeesOfCompanyCountry($companyId: HashedId!, $country: Country) {
    resignedEmployeesOfCompanyCountry(companyId: $companyId, country: $country) {
      employeesWithWrongStatusOrMissingContractDTO {
        fullName
        businessUnitId
      }
      resignedEmployees {
        id
        firstName
        lastName
        level
        businessUnit {
          id
          name
          displayName
          company {
            id
            name
          }
        }
        salary
        currency
        bonus
        startDate
        endDate
        reason
        timezone
        toBePaid {
          amount
          currency
        }
      }
    }
  }
`
